import { useEffect, useState } from 'react'
import {
  Box,
  Typography,
  IconButton,
  CircularProgress
} from '@mui/material'
import axios from 'axios'
import apiUrl from '../../../configs/constant'
import { useToast } from '../../../components/ToastProvider'
import Icon from '../../../components/icon'
import ProductionTimeline from '../../../components/production/ProductionTimeline'

export default function Index() {
  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token
  const { showToast } = useToast()

  const [data, setData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    axios
      .get(apiUrl.apiUrl + '/production/planning-produksi/list-prioritas/1', {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (res.data.success) setData(res.data.data)
        else showToast(res.data.message, 'error')
      })
      .finally(() => setLoading(false))
  }, [])

  const move = (row: any, is_up: number) => {
    axios.post(
      apiUrl.apiUrl + '/production/planning-produksi/save-prioritas',
      { wo_id: row.id, is_up, keterangan: '' },
      { headers: { Authorization: `Bearer ${token}` } }
    )
  }

  if (loading)
    return (
      <Box sx={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    )

  return (
    <Box sx={{ bgcolor: '#0b1220', minHeight: '100vh', p: 4 }}>
      <Typography fontSize={28} fontWeight={900} color="#fff" mb={3}>
        PRODUCTION CONTROL BOARD
      </Typography>

      {data.map((row, index) => (
        <Box
          key={row.id}
          sx={{
            mb: 4,
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0,0,0,.6)',
            bgcolor: '#020617'
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              p: 3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              bgcolor: row.is_target ? '#facc15' : '#111827',
              color: row.is_target ? '#000' : '#fff'
            }}
          >
            <Box>
              <Typography fontWeight={900} fontSize={20}>
                {row.kode}
              </Typography>
              <Typography fontSize={13}>
                {row.produk} • {row.qty} PCS • Deadline {row.deadline || '-'}
              </Typography>
            </Box>

            <Box>
              <IconButton
                disabled={index === 0}
                onClick={() => move(row, 1)}
                sx={{ color: '#22c55e' }}
              >
                <Icon icon="mdi:arrow-up-bold" />
              </IconButton>
              <IconButton
                disabled={index === data.length - 1}
                onClick={() => move(row, 0)}
                sx={{ color: '#ef4444' }}
              >
                <Icon icon="mdi:arrow-down-bold" />
              </IconButton>
            </Box>
          </Box>

          {/* TIMELINE */}
          <ProductionTimeline steps={row.steps || []} />
        </Box>
      ))}
    </Box>
  )
}
